import {useEffect, useState} from 'react'

import {useRouter} from 'next/router'
import styled from 'styled-components'
import classNames from 'classnames'

import {useAuth} from '@festi/common/contexts'

import {usePago} from '../PagoContext'
import PagoRegistrationSteps, {RegistrationStep} from './PagoRegistrationSteps'
import {
  // BudgetTooLow,
  CheckEligibility,
  NotEligible,
  PendingReview,
} from './StatusComponents'

const OverlayRoot = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffffd9;
  backdrop-filter: blur(6px);
  z-index: 2;

  &.hidden {
    display: none;
    pointer-events: none;
  }
`

const OverlayContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  max-width: 400px;
`

export default function PagoRegistration() {
  const router = useRouter()
  const {pagoUserStatus, pagoGateway, handleRegistrationUrl} = usePago()
  const {user} = useAuth()
  const [registrationStep, setRegistrationStep] =
    useState<RegistrationStep | null>(null)

  function getStartingStep() {
    if (pagoUserStatus === 'TERMS_NOT_ACCEPTED') {
      return RegistrationStep.Terms
    }
    if (pagoUserStatus === 'NO_REGISTRATION' && !user?.phoneNumber) {
      return RegistrationStep.PhoneNumber
    }
    return RegistrationStep.KYC
  }

  useEffect(() => {
    !!pagoGateway?.id && !!user?.ssn && handleRegistrationUrl('GET')
  }, [user?.ssn, pagoGateway, handleRegistrationUrl])

  return (
    <>
      <OverlayRoot
        className={classNames({
          hidden:
            pagoUserStatus === 'ELIGABLE' ||
            router.pathname !== '/kaup/greidsla',
        })}
      >
        <OverlayContent>
          {(pagoUserStatus === 'NO_REGISTRATION' ||
            pagoUserStatus === 'TERMS_NOT_ACCEPTED' ||
            pagoUserStatus === 'NEEDS_TO_PERFORM_KYC') && (
            <CheckEligibility
              openRegistrationModal={() =>
                setRegistrationStep(getStartingStep())
              }
            />
          )}
          {/* TODO: Add amounts from data */}
          {/* {pagoUserStatus === 'BUDGET_TOO_LOW' && (
            <BudgetTooLow creditAmount={80000} purchaseAmount={99995} />
          )} */}
          {pagoUserStatus === 'CREDIT_CHECK_NOT_VALID' && <NotEligible />}
          {pagoUserStatus === 'KYC_REJECTED' && <NotEligible />}
          {pagoUserStatus === 'ERROR' && <NotEligible />}
          {pagoUserStatus === 'KYC_PENDING' && <PendingReview />}
          {pagoUserStatus === 'BAD_GATEWAY' && <PendingReview />}
        </OverlayContent>
      </OverlayRoot>

      <PagoRegistrationSteps
        step={registrationStep}
        setStep={setRegistrationStep}
      />
    </>
  )
}
